import { setToken, setTenantId, setBid } from "@/utils/auth";

/**
 * 维护本地储存的授权相关信息
 */

// 设置数据
export function setData(token, tenantId, bid) {
  setToken(token);
  setTenantId(tenantId);
  setBid(bid);
}

// 清除数据
export function clearData() {
  setToken("");
  setTenantId("");
  setBid("");
}
